import { render, staticRenderFns } from "./PassengerInformationSummary.vue?vue&type=template&id=bfd6ec3c&scoped=true"
import script from "./PassengerInformationSummary.vue?vue&type=script&lang=js"
export * from "./PassengerInformationSummary.vue?vue&type=script&lang=js"
import style0 from "./PassengerInformationSummary.vue?vue&type=style&index=0&id=bfd6ec3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfd6ec3c",
  null
  
)

export default component.exports